// extracted by mini-css-extract-plugin
module.exports = {"pictureTextContainer":"PictureTextRight_pictureTextContainer__pr0TV","imageWrapper":"PictureTextRight_imageWrapper__V-JYR","textContainer":"PictureTextRight_textContainer__22qbZ"};